import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TCase } from '../../models';

export const CaseComponent: FC<React.PropsWithChildren<TCase>> = ({
    children,
    className,
    id,
    keepMount,
    styles,
    visibleId,
}) => {
    if (visibleId === id)
        return (
            <div aria-hidden="false" className={className}>
                {children}
            </div>
        );

    if (keepMount)
        return (
            <div aria-hidden="true" className={cn(className, styles.hidden)}>
                {children}
            </div>
        );

    return null;
};
